import { defineStore } from 'pinia';

export const useSidebarStore = defineStore('sidebar', {
  state: () => ({
    mobileOpen: false,
    showSubtractedSidebar: false,
    showFullSidebar: true,
    closeSidebarIcon: true,
  }),

  actions: {
    updateMobileOpen(value) {
      this.mobileOpen = value;

      if (window.innerWidth >= 768 && window.innerWidth <= 1239) {
        this.updateMidPointSidebar(value);
      } else if (window.innerWidth < 768) {
        this.updateMobileSidebar(value);
      } else if (window.innerWidth > 1239) {
        this.updateSidebar(value);
      }
    },

    updateSidebar(value) {
      if (value) {
        this.showSubtractedSidebar = value;
        this.showFullSidebar = false;
        this.closeSidebarIcon = false;
      } else {
        this.showSubtractedSidebar = value;
        this.showFullSidebar = true;
        this.closeSidebarIcon = true;
      }
    },

    updateMidPointSidebar(value) {
      if (value) {
        this.showSubtractedSidebar = true;
        this.showFullSidebar = false;
        this.closeSidebarIcon = false;
      } else {
        this.showSubtractedSidebar = true;
        this.showFullSidebar = true;
        this.closeSidebarIcon = true;
      }
    },

    updateMobileSidebar(value) {
      this.showSubtractedSidebar = false;
      this.showFullSidebar = true;
      this.closeSidebarIcon = value;
    },
  },
});
